import script from "./NoteGeneralForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteGeneralForm.vue?vue&type=script&setup=true&lang=js"

import "./NoteGeneralForm.vue?vue&type=style&index=0&id=0a3bc691&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3bc691"]])

export default __exports__